import React from 'react';
import { PhosphorIcon } from '../../users/conversation_room/phosphor_icons';

export const ICON_PATHS = {
  user: {
    viewBox: '0 0 16 16',
    paths: [
      {
        d: 'M14.4331 13.75C14.3892 13.826 14.3261 13.8892 14.2501 13.933C14.174 13.9769 14.0878 14 14 14H2C1.91228 13.9999 1.82612 13.9767 1.75018 13.9328C1.67424 13.8889 1.6112 13.8258 1.56737 13.7498C1.52355 13.6738 1.50049 13.5876 1.50051 13.4999C1.50054 13.4121 1.52364 13.326 1.5675 13.25C2.51937 11.6044 3.98625 10.4244 5.69812 9.865C4.85135 9.36091 4.19347 8.5928 3.82549 7.67862C3.45752 6.76444 3.3998 5.75475 3.66121 4.8046C3.92262 3.85445 4.4887 3.01637 5.27252 2.41908C6.05633 1.82178 7.01454 1.4983 8 1.4983C8.98546 1.4983 9.94367 1.82178 10.7275 2.41908C11.5113 3.01637 12.0774 3.85445 12.3388 4.8046C12.6002 5.75475 12.5425 6.76444 12.1745 7.67862C11.8065 8.5928 11.1486 9.36091 10.3019 9.865C12.0138 10.4244 13.4806 11.6044 14.4325 13.25C14.4765 13.326 14.4997 13.4121 14.4998 13.4999C14.4999 13.5877 14.4769 13.6739 14.4331 13.75Z',
      },
    ],
  },
  gear: {
    viewBox: '0 0 16 16',
    paths: [
      {
        d: 'M14.8713 6.70063C14.8573 6.63022 14.8284 6.56363 14.7864 6.50539C14.7445 6.44716 14.6905 6.39863 14.6281 6.36313L12.7638 5.30062L12.7563 3.19937C12.756 3.12701 12.7401 3.05555 12.7096 2.98995C12.679 2.92434 12.6346 2.86614 12.5794 2.81938C11.9031 2.24731 11.1243 1.80892 10.2844 1.5275C10.2182 1.50511 10.1481 1.49683 10.0786 1.50318C10.0091 1.50953 9.94162 1.53038 9.88063 1.56438L8 2.61562L6.1175 1.5625C6.05647 1.52831 5.98895 1.50731 5.91929 1.50085C5.84964 1.49439 5.7794 1.50262 5.71312 1.525C4.87373 1.80822 4.09578 2.24832 3.42062 2.82188C3.36548 2.86857 3.32111 2.92667 3.29058 2.99216C3.26004 3.05766 3.24407 3.12899 3.24375 3.20125L3.23438 5.30438L1.37 6.36688C1.30763 6.40238 1.25363 6.45091 1.21168 6.50914C1.16972 6.56738 1.1408 6.63397 1.12688 6.70438C0.956248 7.5618 0.956248 8.44445 1.12688 9.30188C1.1408 9.37228 1.16972 9.43887 1.21168 9.49711C1.25363 9.55534 1.30763 9.60387 1.37 9.63937L3.23438 10.7019L3.24187 12.8038C3.2421 12.8761 3.25803 12.9476 3.28857 13.0132C3.31911 13.0788 3.36352 13.137 3.41875 13.1838C4.09504 13.7558 4.87385 14.1942 5.71375 14.4756C5.77989 14.498 5.84999 14.5063 5.91953 14.4999C5.98907 14.4936 6.05651 14.4727 6.1175 14.4388L8 13.3844L9.8825 14.4375C9.957 14.479 10.041 14.5005 10.1263 14.5C10.1809 14.5 10.2351 14.4911 10.2869 14.4738C11.1261 14.1907 11.904 13.751 12.5794 13.1781C12.6345 13.1314 12.6789 13.0733 12.7094 13.0078C12.74 12.9423 12.7559 12.871 12.7563 12.7988L12.7656 10.6956L14.63 9.63313C14.6924 9.59762 14.7464 9.54909 14.7883 9.49086C14.8303 9.43262 14.8592 9.36603 14.8731 9.29562C15.0428 8.43888 15.0422 7.55712 14.8713 6.70063ZM8 10.5C7.50555 10.5 7.0222 10.3534 6.61107 10.0787C6.19995 9.80397 5.87952 9.41352 5.6903 8.95671C5.50108 8.49989 5.45157 7.99723 5.54804 7.51227C5.6445 7.02732 5.8826 6.58186 6.23223 6.23223C6.58186 5.8826 7.02732 5.6445 7.51227 5.54804C7.99723 5.45157 8.49989 5.50108 8.95671 5.6903C9.41352 5.87952 9.80397 6.19995 10.0787 6.61107C10.3534 7.0222 10.5 7.50555 10.5 8C10.5 8.66304 10.2366 9.29893 9.76777 9.76777C9.29893 10.2366 8.66304 10.5 8 10.5Z',
      },
    ],
  },
  shield: {
    viewBox: '0 0 16 16',
    paths: [
      {
        d: 'M13 2.5H3C2.73478 2.5 2.48043 2.60536 2.29289 2.79289C2.10536 2.98043 2 3.23478 2 3.5V7C2 10.295 3.595 12.2919 4.93313 13.3869C6.37437 14.5656 7.80813 14.9656 7.87063 14.9825C7.95656 15.0059 8.04719 15.0059 8.13313 14.9825C8.19563 14.9656 9.6275 14.5656 11.0706 13.3869C12.405 12.2919 14 10.295 14 7V3.5C14 3.23478 13.8946 2.98043 13.7071 2.79289C13.5196 2.60536 13.2652 2.5 13 2.5ZM10.855 6.85375L7.355 10.3538C7.30856 10.4002 7.25342 10.4371 7.19272 10.4623C7.13202 10.4874 7.06696 10.5004 7.00125 10.5004C6.93554 10.5004 6.87048 10.4874 6.80978 10.4623C6.74908 10.4371 6.69394 10.4002 6.6475 10.3538L5.1475 8.85375C5.05368 8.75993 5.00097 8.63268 5.00097 8.5C5.00097 8.36732 5.05368 8.24007 5.1475 8.14625C5.24132 8.05243 5.36857 7.99972 5.50125 7.99972C5.63393 7.99972 5.76118 8.05243 5.855 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375H10.855Z',
      },
    ],
  },
  id: {
    viewBox: '0 0 12.35 8.879',
    paths: [
      {
        d: 'M10.803 0H1.547C0.702 0 0 0.689 0 1.547V7.332C0 8.177 0.689 8.879 1.547 8.879H10.803C11.648 8.879 12.35 8.19 12.35 7.332V1.534C12.35 0.689 11.661 0 10.803 0ZM3.861 1.924C4.498 1.924 5.018 2.444 5.018 3.081C5.018 3.718 4.498 4.238 3.861 4.238C3.224 4.238 2.704 3.718 2.704 3.081C2.704 2.444 3.224 1.924 3.861 1.924ZM5.824 6.942H1.898C1.781 6.942 1.664 6.89 1.599 6.799C1.521 6.708 1.495 6.591 1.534 6.474C1.794 5.395 2.756 4.628 3.874 4.628C4.953 4.628 5.889 5.343 6.175 6.383C6.201 6.435 6.214 6.487 6.214 6.552C6.214 6.773 6.045 6.942 5.824 6.942ZM8.489 5.395H6.942C6.734 5.395 6.552 5.226 6.552 5.005C6.552 4.797 6.721 4.615 6.942 4.615H8.489C8.697 4.615 8.879 4.784 8.879 5.005C8.879 5.226 8.71 5.395 8.489 5.395ZM10.426 3.848H6.942C6.734 3.848 6.552 3.679 6.552 3.458C6.552 3.25 6.721 3.068 6.942 3.068H10.413C10.621 3.068 10.803 3.237 10.803 3.458C10.803 3.679 10.634 3.848 10.426 3.848Z',
      },
    ],
  },
  envelope: {
    viewBox: '0 0 15 15',
    paths: [
      {
        d: 'M11.875 3.125H3.125C2.43464 3.125 1.875 3.68464 1.875 4.375V10.625C1.875 11.3154 2.43464 11.875 3.125 11.875H11.875C12.5654 11.875 13.125 11.3154 13.125 10.625V4.375C13.125 3.68464 12.5654 3.125 11.875 3.125Z',
      },
      {
        d: 'M1.875 4.375L7.5 8.125L13.125 4.375',
        fill: 'none',
        stroke: 'white',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
    ],
  },
  phone: {
    viewBox: '0 0 16 16',
    paths: [
      {
        d: 'M14.2427 10.9419C14.1313 11.7888 13.7154 12.5662 13.0727 13.1288C12.43 13.6915 11.6044 14.0009 10.7502 13.9994C5.78775 13.9994 1.75025 9.96189 1.75025 4.99939C1.74871 4.1452 2.05818 3.31965 2.62083 2.67695C3.18348 2.03424 3.96085 1.61833 4.80775 1.50689C5.0219 1.48074 5.23878 1.52455 5.42599 1.63179C5.6132 1.73902 5.76071 1.90393 5.8465 2.10189L7.1665 5.04876V5.05626C7.23218 5.2078 7.2593 5.37324 7.24545 5.53781C7.2316 5.70238 7.1772 5.86097 7.08712 5.99939C7.07587 6.01626 7.064 6.03189 7.0515 6.04751L5.75025 7.59001C6.21837 8.54126 7.21337 9.52751 8.17712 9.99689L9.69837 8.70251C9.71331 8.68996 9.72896 8.67827 9.74525 8.66751C9.88355 8.57527 10.0427 8.51896 10.2082 8.50368C10.3738 8.4884 10.5405 8.51464 10.6934 8.58001L10.7015 8.58376L13.6459 9.90314C13.8442 9.98862 14.0095 10.136 14.1171 10.3232C14.2247 10.5105 14.2688 10.7275 14.2427 10.9419Z',
      },
    ],
  },
  signout: {
    viewBox: '0 0 14 14',
    paths: [
      {
        d: 'M6.5625 11.8125C6.5625 11.9285 6.51641 12.0398 6.43436 12.1219C6.35231 12.2039 6.24103 12.25 6.125 12.25H2.625C2.50897 12.25 2.39769 12.2039 2.31564 12.1219C2.23359 12.0398 2.1875 11.9285 2.1875 11.8125V2.1875C2.1875 2.07147 2.23359 1.96019 2.31564 1.87814C2.39769 1.79609 2.50897 1.75 2.625 1.75H6.125C6.24103 1.75 6.35231 1.79609 6.43436 1.87814C6.51641 1.96019 6.5625 2.07147 6.5625 2.1875C6.5625 2.30353 6.51641 2.41481 6.43436 2.49686C6.35231 2.57891 6.24103 2.625 6.125 2.625H3.0625V11.375H6.125C6.24103 11.375 6.35231 11.4211 6.43436 11.5031C6.51641 11.5852 6.5625 11.6965 6.5625 11.8125ZM12.5595 6.69047L10.372 4.50297C10.3108 4.44171 10.2329 4.39999 10.1479 4.38308C10.063 4.36617 9.97501 4.37484 9.89503 4.40798C9.81504 4.44112 9.74669 4.49725 9.69862 4.56926C9.65055 4.64127 9.62493 4.72592 9.625 4.8125V6.5625H6.125C6.00897 6.5625 5.89769 6.60859 5.81564 6.69064C5.73359 6.77269 5.6875 6.88397 5.6875 7C5.6875 7.11603 5.73359 7.22731 5.81564 7.30936C5.89769 7.39141 6.00897 7.4375 6.125 7.4375H9.625V9.1875C9.62493 9.27408 9.65055 9.35873 9.69862 9.43074C9.74669 9.50275 9.81504 9.55888 9.89503 9.59202C9.97501 9.62516 10.063 9.63383 10.1479 9.61692C10.2329 9.60001 10.3108 9.55829 10.372 9.49703L12.5595 7.30953C12.6002 7.2689 12.6325 7.22065 12.6545 7.16754C12.6765 7.11442 12.6878 7.05749 12.6878 7C12.6878 6.94251 12.6765 6.88558 12.6545 6.83246C12.6325 6.77935 12.6002 6.7311 12.5595 6.69047Z',
      },
    ],
  },
  trash:
    'M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm32,152a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm40,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z',
};

export function Icon({ path, size = 16 }) {
  if (typeof path === 'object') {
    return (
      <svg
        width={size}
        height={size}
        viewBox={path.viewBox}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
      >
        {path.paths.map((segment) => (
          <path
            key={segment.d}
            d={segment.d}
            fill={segment.fill === 'none' ? 'none' : 'currentColor'}
            stroke={segment.stroke}
            strokeLinecap={segment.strokeLinecap}
            strokeLinejoin={segment.strokeLinejoin}
          />
        ))}
      </svg>
    );
  }

  return <PhosphorIcon path={path} size={size} />;
}

export function CaretRight() {
  return (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
      <path d='M9 18L15 12L9 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

export function CaretLeftIcon({ className, strokeWidth = 2.4 }) {
  return (
    <svg className={className} width='20' height='20' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
      <polyline
        points='15 18 9 12 15 6'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function SidebarChevronDown({ className }) {
  return (
    <svg className={className} width='18' height='18' viewBox='0 0 18 18' fill='none' aria-hidden='true'>
      <path
        d='M4.5 6.75L9 11.25L13.5 6.75'
        stroke='rgba(255, 255, 255, 0.4)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function displayNameFor(user) {
  return (
    user?.profile?.display_name ||
    user?.display_name ||
    user?.name ||
    [user?.first_name, user?.last_name].filter(Boolean).join(' ') ||
    'PatientPartner'
  );
}

export function initialsFor(name) {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
